import * as _ from 'lodash';
// tslint:disable-next-line:max-line-length

angular.module('nv.support-overview').component('supportAttendanceLogs', {
  template: require('./support-attendance-logs.html'),
  bindings: {
    attendanceRecords: '<',
    studentSupports: '<',
    support: '<',
    toggleView: '&',
  },
  controller($state, SpinnerModal, SupportAttendanceService, UtilitiesService) {
    this.onEditAttendanceClick = function(supportId, eventDate, _isUnlogged) {
      SpinnerModal.activateSpinner(`Loading attendance data...`);
      const edit = true;
      const isUnlogged = _isUnlogged || false;
      $state.go('main.school.support-attendance-form', { supportId, eventDate, edit, isUnlogged });
    };

    this.getHumanDate = function(isoDate) {
      return UtilitiesService.convertISODateToHumanDate(isoDate);
    };

    this.findStudentById = function(studentId, studentSupports) {
      return _.result(
        studentSupports.find(studentSupport => studentId === studentSupport.student.studentId),
        'student.lastFirst',
      );
    };

    this.$onInit = () => {
      // Load the toggleView callback, toggles between student/eventDate log summaries
      this.onToggle = this.toggleView();

      // Get the % average for each PRESENT, LATE, ABSENT
      // Summarize by studentId
      const summarizedRecords = SupportAttendanceService.summarizeAttendanceData(this.attendanceRecords, 'eventDate');

      // Figure out which logs are missing
      const missingLogs = SupportAttendanceService.getMissingAttendanceDates(
        this.support,
        this.attendanceRecords,
        this.studentSupports,
        true,
      );
      // Append and sort logged and missinglogs objs for view
      const allRecords = [].concat(summarizedRecords, missingLogs);
      const sortedRecords = _.orderBy(allRecords, ['eventDate'], ['desc']);
      this.recordsByEventDate = sortedRecords;
      this.supportIsNotStarted = this.support.isNotStarted();
    };
  },
});
